export const inputElementModel = {
  type: "text",
  id: "",
  name: "",
  value: "",
  onChange: () => {},
  placeholder: "",
  label: "",
  error: "",
  required: false,
  disabled: false,
  className: "",
  style: {},
  removeDefaultStyle: false,
  checked: false,
};
